import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {CURSOR,UNSET} from '../../../styles/fonts/MCFontConstants';
export const ItemsCardContainer = styled.div`
    display: flex;
    background: #ffffff 0% 0% no-repeat padding-box;
    border-radius: 6px;
    margin: ${({ marginOnLargeDevice }) =>
        marginOnLargeDevice ? marginOnLargeDevice : '10px 5px 5px 5px'};
    border: ${({ fullBorder }) => (fullBorder ? fullBorder : '')};
    border-left: ${(props) => props.border.border};
    min-width: ${(props) =>
        props.minWidth.minWidth ? props.minWidth.minWidth : '100%'};
    box-shadow: ${(props) =>
        props.boxShadow ? props.boxShadow : '0px 0px 6px #00000029'};
    width: ${({ width }) => width};
    @media only screen and (min-device-width: 667px) and (max-device-width: 1023px) and (orientation : landscape) {
        width: ${({ ipadwidth }) => ipadwidth};
        height: ${({ landscapeHeight }) => landscapeHeight};
        min-width: ${(props) =>
        props.landscapeMinWidth.landscapeMinWidth ? props.landscapeMinWidth.landscapeMinWidth : 'none'};
    }

    ${media.mediumDevice`
    margin: ${({ marginOnMediumDevice }) =>
        marginOnMediumDevice ? marginOnMediumDevice : '10px 5px 5px 5px'};
    
        `}

    ${media.mobileDevice`
        min-width: {({ itemCardsContainerMinMobWidth }) => (itemCardsContainerMinMobWidth ? itemCardsContainerMinMobWidth : '100%')};;  
        margin:${({ margin }) => (margin ? margin : '10px 0px')};
        width: ${({ mobileWidth }) => mobileWidth};
    `}
    height: ${({ height }) => (height ? height : '')};

    @media only screen and (min-device-width: 1024px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        min-width: ${({ enableTemplateCardSpecificStyling }) =>
            enableTemplateCardSpecificStyling && '100%'};
    } ;
`;

export const CheckBoxContainer = styled.div`
    padding-top: 19px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
`;

export const RowContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'relative' : ''};
    padding: ${(props) =>
        props.contentPadding ? props.contentPadding : '15px 15px 0px 15px'};
    width: 100%;
`;

export const ColumnContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* &.setName {
        color: #1010eb;
        font-family: 'AvenirNextWorld Demi';
        font-size: 16px;
    } */

    &.setCount {
        color: #000000;
        font-family: 'AvenirNextWorld Regular';
        font-size: 14px;
    }

    &.type {
        background: #ebebeb 0% 0% no-repeat padding-box;
        border-radius: 10px;
        display: inline;
        padding-left: 5px;
        padding-right: 5px;
        margin-left: 5px;
    }
`;

export const SetsAndItemsValues = styled.div`
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    color: #000000;
    margin-left: 0px;
    font-size: ${({ setOrItemDetailsFontSizeMobile }) =>
        setOrItemDetailsFontSizeMobile
            ? setOrItemDetailsFontSizeMobile
            : '14px'};

    opacity: 1;
    word-break: break-word;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    // 10-20mm coming on same line
    width: ${({ width }) => (width ? width : '')};
    min-width: ${({ minWidth }) => (minWidth ? minWidth : '280px')};
    margin-top: ${({ isEquity, marginTop }) =>
        isEquity ? '-4px' : marginTop ? marginTop : '6px'};

    ${media.mobileDevice`     
        font-size: ${({ setOrItemDetailsFontSizeMobile }) =>
            setOrItemDetailsFontSizeMobile
                ? setOrItemDetailsFontSizeMobile
                : '13px'};
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '')};
        height: ${({ mbHeight }) => (mbHeight ? mbHeight : '')};
    `}
`;

export const SetName = styled.div`
    color: ${(props) => (props.color ? props.color : '#130e4a')};
    font-family: 'AvenirNextWorld Demi';
    font-size: ${(props) =>
        props.fontSizeDesktop ? props.fontSizeDesktop : '18px'};
    cursor: ${(props) => (props.clickable ? 'pointer' : '')};
    ${media.mobileDevice`     
        font-size: ${(props) =>
            props.fontSizeMobile ? props.fontSizeMobile : '18px'};
    `}
    letter-spacing: ${(props) =>
        props.setNameLetterSpacing ? props.setNameLetterSpacing : 'normal'};
    line-height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '20px' : 'unset'};
    white-space: ${(props) =>
        props.enableTemplateCardSpecificStyling
            ? props.setNameStyle
                ? 'nowrap'
                : ' break-spaces'
            : 'unset'};
    width: ${({ setNameWidth }) => (setNameWidth ? setNameWidth : '')};
    word-break: ${(props) => (props.setNameBreak ? props.setNameBreak : '')};
    text-overflow: ${({ setNameTextOverflow }) =>
        setNameTextOverflow ? setNameTextOverflow : ''};
    overflow: ${({ setNameOverflow }) =>
        setNameOverflow ? setNameOverflow : ''};
`;

export const SetCount = styled.div`
    color: #000000;
    font-family: 'AvenirNextWorld Regular';
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
`;

export const Type = styled.div`
    background: ${({ backGround }) =>
        backGround ? backGround : '#ebebeb 0% 0% no-repeat padding-box'};
    border-radius: 10px;
    display: inline;
    padding-left: 6px;
    padding-right: 6px;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '5px')}; 
    color: #140f4b;
    font-size: ${({ typeFontSize }) => (typeFontSize ? typeFontSize : '13px')};
    text-align: center;
    white-space: nowrap;
     ${media.ipadAir`
        margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '20px')};
     `}
`;
export const ActionButton = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: ${({ enableTemplateCardSpecificStyling, center }) =>
        center
            ? 'center'
            : enableTemplateCardSpecificStyling
            ? 'flex-start'
            : 'center'};
    ${media.mobileDevice`     
     
     `}
`;
export const Status = styled.div`
    height: 22px;
    background: #ebebeb 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    align-items: center;
    text-align: center;
    ${media.mobileDevice`
        border-radius: 10px;
    `}
`;
export const StatusText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    letter-spacing: -0.1px;
    color: #140f4b;
    //height: 17px;
    width: 100%;
    padding: 0px 5px;
    text-align: center;
`;
export const CardFooter = styled.div`
    display: flex;
    flex-direction: ${({ cardFlexDirection }) => cardFlexDirection};
    margin: ${({ cartFooterMargin }) =>
        cartFooterMargin ? cartFooterMargin : '5px 0px 12px 0px'};
    justify-content: ${({ justifyContentWithoutBrand }) =>
        justifyContentWithoutBrand ? 'flex-end' : 'space-between'};
    align-items: left;
    ${media.mobileDevice`     
        margin:${(props) =>
            props.enableTemplateCardSpecificStyling
                ? '10px 0px 17px 0px'
                : '5px 0px 12px 0px'}; 
     `}
    position:${(props) =>
        props.enableTemplateCardSpecificStyling ? 'absolute' : ''};
    bottom: ${(props) => (props.enableTemplateCardSpecificStyling ? '0' : '')};
    width: ${(props) => (props.cardFooterWidth ? props.cardFooterWidth : '')};

    flex-wrap: nowrap;
    flex-direction: ${({ showBrand }) => (showBrand ? 'row' : 'column')};
`;
export const Brands = styled.div`
    display: flex;
    font-family: 'AvenirNextWorld Demi';
    text-align: left;
    align-self: ${({ alignSelf }) => alignSelf};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    color: ${({ color }) => (color ? color : '#000000')};
    font-size: 13px;
    word-break: ${({ wordBreak }) => wordBreak};
    ${media.mobileDevice`     
     
     `};
`;
export const BrandsName = styled.div`
    display: block;
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '')};
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    font-size: 14px;
    color: ${({ color }) => (color ? color : '#000000')};
    margin: 0 2px 0 0px;
    padding-left: ${({ isEquityOrder }) => (isEquityOrder ? '3px' : '0px')};
    ${media.mediumDevice`     
    display:${({ IsConsignmentBillingOrder }) =>
        IsConsignmentBillingOrder ? 'contents' : 'block'};
     `}
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        display: ${({ IsConsignmentBillingOrder }) =>
            IsConsignmentBillingOrder ? 'contents' : 'block'};
    }
    ${media.mobileDevice`    
    display:${({ IsConsignmentBillingOrder }) =>
        IsConsignmentBillingOrder ? 'block' : 'contents'}; 
    margin:0 2px 0 0px;
     `}
`;
export const StatusName = styled.div`
    display: block;
    text-align: left;
    font-family: 'AvenirNextWorld Regular';
    letter-spacing: ${({ letterSpacing }) =>
        letterSpacing ? letterSpacing : '-0.11px'};
    font-size: 13px;
    color: ${({ color }) => (color ? color : '#000000')};
    margin: 0 2px 0 0;
    padding-left: ${({ isEquityOrder }) => (isEquityOrder ? '3px' : '0px')};
`;
export const Counter = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    align-items: center;
    //adjusted counter
    margin: auto 0px;    
    text-align: center;
    letter-spacing: -0.13px;
    color: ${({ color }) => (color ? color : '#1021ec')};
    opacity: 1;
    padding: ${({ isSurgery }) => (isSurgery ? '0 10px' : '0')};


    ${media.mobileDevice`     
     `}
`;
export const AddedText = styled.div`
    color: #14853d;
    font-family: 'AvenirNextWorld Regular';
    font-size: 11px;
    margin-right: 10px;
`;
//product templates
export const UserAndFavoritesContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const UserNameAndDateContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 157px;
    /* ${media.mobileDevice`
       margin-right: 170px;
    `}; */
    & .userName {
        letter-spacing: 0;
        text-align: left;
        font-family: 'AvenirNextWorld Demi';
        letter-spacing: 0px;
        color: #140f4b;
        opacity: 1;
        font-size: 14px;
        padding-left: 7px;
        white-space: pre;
    }

    & .dateStamp {
        text-align: left;
        font-family: 'AvenirNextWorld Regular';
        letter-spacing: -0.1px;
        color: #000000;
        opacity: 0.6;
        font-size: 12px;
        margin-top: -5px;
        padding-left: 7px;
    }
`;

export const FavoriteIconContainer = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 6px;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: ${(props) =>
        props.enableTemplateCardSpecificStyling ? 'absolute' : ''};
    right: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '15px' : ''};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    max-width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    min-width: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    height: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '30px' : ''};
    bottom: ${(props) =>
        props.enableTemplateCardSpecificStyling ? '4px' : 'unset'};
`;

export const Icon = styled.img.attrs((props) => ({
    src: props.mobilePath,
}))`
    width: 22px;
    height: 23px;
    cursor: ${(props) => (props.hideCursor ? UNSET : CURSOR)};
    ${media.mobileDevice`
   
    `}
`;

export const ProductTemplateTitle = styled.div`
    color: #1010eb;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
`;

export const ProductTemplateDetailsHeader = styled.div`
    letter-spacing: 0;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: 0px;
    color: #140f4b;
    opacity: 1;
    font-size: 14px;
    //align text left
    //padding-left: 7px;
    white-space: pre;
    margin-top: 20px;
`;
export const NoShipText = styled.label`
    font-size: 12px;
    color: ${({ color }) => (color ? color : '#f6610b')};
    font-family: 'AvenirNextWorld Demi';
    margin: ${({ margin }) => margin};
`;
export const SetLocatedText = styled.label`
    font-size: 14px;
    color: #202124;
    font-family: 'AvenirNextWorld Demi';
    margin-top: 5px;
`;
export const SetLocatedRowDiv = styled.div`
    display: flex;
    flex-direction: row;
    align-items: ${({ alignItem }) => (alignItem ? alignItem : 'flex-start')};
    margin-bottom: 5px;
`;
export const BatchText = styled.div`
    color: #101010;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    width: ${(props) => props.width};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-bottom: ${(props) => props.paddingBottom};
`;
export const ParkedLabel = styled.label`
    font-size: 10px;
    border: 1px solid #008d00;
    padding: 2px;
    border-radius: 10px;
    background: #cbffd2;
    width: 50px;
    text-align: center;
    color: #008d00;
`;
export const AllocatedText = styled.label`
    color: #131313;
    font-size: 10px;
    font-family: 'AvenirNextWorld Regular';
`;
export const RedCircle = styled.div`
    height: 10px;
    width: 10px;
    background-color: #ed002a;
    border-radius: 5px;
    margin-right: 2px;
    color: #ffffff;
    font-size: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3.5px;
`;
export const PhysicianAndAccount = styled.div`
    display: flex;
    flex-direction: column;
    margin: 5px 0 0 0;
`;

export const Account = styled.div`
    display: flex;
    flex-direction: ${(props) =>
        props.flexDirection ? props.flexDirection : 'row'};
    flex-wrap: nowrap;
    min-width: 0;
`;

export const AccountName = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    max-width: ${({ truncate }) => (truncate ? '62%' : 'unset')};
`;

export const AccountId = styled.div`
    display: flex;
    flex-shrink: 0;
    font-family: 'AvenirNextWorld Italic';
    font-size: 14px;
    margin: 0 0 0 5px;
`;

export const Physician = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-width: 0;
`;

export const PhysicianName = styled.p`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    max-width: ${({ truncate }) => (truncate ? '62%' : 'unset')};
`;

export const PhysicianId = styled.div`
    display: flex;
    flex-shrink: 0;
    font-family: 'AvenirNextWorld Italic';
    font-size: 14px;
    margin: 0 0 0 5px;
`;

export const Parked = styled.div`
    color: #008d00;
    font-family: 'AvenirNextWorld Demi';
    font-size: 10px;
    border: 0.5px solid #00610099;
    background: #cbffd2;
    width: 20%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 17px;
    height: 18px;
`;
export const AddedCartButton = styled.div`
    ${({ hasBadge }) => hasBadge ? 'position: relative;' : ''}
    width: ${({ width }) => (width ? width : '30px')};
    height: ${({ height }) => (height ? height : '30px')};
    display: ${({ display }) => (display ? display : 'flex')};
    visibility: ${({ visibility }) => visibility};
    justify-content: center;
    align-items: center;
    border: ${({ border }) => (border ? border : '1px solid #ebebeb')};
    box-shadow: ${({ shadow }) => (shadow ? shadow : '0px 0px 2px #00000029')};
    border-radius: 6px;
    opacity: 1;
    background-color : white;
    ${({ noShrink }) => noShrink ? 'flex-shrink: 0;' : ''}
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '0px')};
    @media only screen and (min-width: 577px) and (max-width: 1024px) {
        margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '0px')};
    }
`;
export const AddCartIcon = styled.img.attrs((props) => ({
    src: props.mobilePath,
    id : props.id ? props.id : 'add-cart-icon',
}))`
    width: ${({ width }) => (width ? width : '14px')};
    height: ${({ height }) => (height ? height : '14px')};
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};

    cursor: pointer;
    ${media.mobileDevice`
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '14px')};
        height: ${({ mbHeight }) => (mbHeight ? mbHeight : '14px')};
    `}
`;

export const MoreItemView = styled.div`
    margin: 2.25px 0px 0px 8px;
    color: #1010eb;
    font-size: 11px;
    font-family: 'AvenirNextWorld Regular';
    cursor: pointer;
`;

export const AccountAndID = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    min-width: 0;
`;
export const ReservationText = styled.div`
    font-size: 13px;
    color: #c121eb;
    font-family: 'AvenirNextWorld Demi';
    line-height: 22.59px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
    width: 100%;
`;
export const WarningText = styled.div`
    font-size: 13px;
    color: #b56409;
    font-family: 'AvenirNextWorld Regular';
    line-height: 22.59px;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -3px;
    margin-left: 5px;
    ${media.mobileDevice`
        font-size: 12px;
   
        `}
`;

export const WarningTextType = styled.div`
    font-size: 13px;
    color: #b56409;
    font-family: 'AvenirNextWorld Demi';
    line-height: 22.59px;
    width: '';
    font-weight: bold;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -3px;
    margin-left: 5px;
    ${media.mobileDevice`
        font-size: 12px;
   
        `}
`;
export const WarningTextContainer = styled.span`
    color: #b56409;
    font-size: 13px;
    font-family: 'AvenirNextWorld Regular';
    display: flex;
    // margin-bottom: 0px;
    // align-items: center;
`;
